<template>
  <div class="content-warp" v-if="personInfo">
    <a-row class="brief-bar" type="flex" justify="space-between" align="middle">
      <a-row type="flex" justify="start" align="middle">
        <a-col class="brief-title">{{personInfo.deptFullName}}</a-col>
        <a-col class="brief-subtitle"></a-col>
        <a-col class="brief-subtitle"></a-col>
      </a-row>
      <a-col style="color: #999;">{{$t('personalManaEdit.creationTime')}}：{{personInfo.createdAt}}</a-col>
    </a-row>

    <a-form :form="form" @submit.prevent="handlePersonInfoSubmit">
      <a-row class="content-panle bg-white margin-0" :gutter="30">
        <a-col :span="24" class="padding-tb-md">
          <h3 class="panle-head">{{$t('personalManaEdit.photosTitle')}}</h3>
          <!-- 现场照 1 -->
          <a-form-item class="inline-form-item" :label="$t('personalManaEdit.photoTxt1')">
            <a-card class="a-card-image">
              <img
                v-if="!currentImage"
                src="../../assets/empty_person.png"
                slot="cover"
              />
              <img v-else :src="currentImage" slot="cover" />

              <template class="ant-card-actions" slot="actions">
                <span @click="()=>{takePhotoModalVisible=true;takePhotoType=1;}" style="color: rgba(0, 0, 0, 0.65);">
                  <a-icon type="camera" /> {{$t('personalManaEdit.takePhotoBtn')}}
                </span>

                <a-upload
                  accept="image/jpeg,image/jpg,image/png"
                  :showUploadList="false"
                  :beforeUpload="file => handleBeforeUploadPhoto(file, 1)"
                  v-decorator="[ 'currentImage', {
                      rules: [
                        { required: false, message: $t('personalManaEdit.photoTxt1Blank') }
                      ]
                    },
                  ]"
                >
                  <a-icon :type="currentImgUploading?'loading':'upload'" /> {{$t('personalManaEdit.uploadPhotoBtn')}}
                </a-upload>
              </template>
            </a-card>
          </a-form-item>
          <!-- 现场照 2 -->
          <a-form-item class="inline-form-item" :label="$t('personalManaEdit.photoTxt2')">
            <a-card class="a-card-image">
              <img
                v-if="!currentWithMaskImage"
                src="../../assets/empty_person.png"
                slot="cover"
              />
              <img v-else :src="currentWithMaskImage" slot="cover" />

              <template class="ant-card-actions" slot="actions">
                <span @click="()=>{takePhotoModalVisible=true;takePhotoType=2;}" style="color: rgba(0, 0, 0, 0.65);">
                  <a-icon type="camera" /> {{$t('personalManaEdit.takePhotoBtn')}}
                </span>

                <a-upload
                  accept="image/jpeg,image/jpg,image/png"
                  :showUploadList="false"
                  :beforeUpload="file => handleBeforeUploadPhoto(file, 2)"
                  v-decorator="['currentWithMaskImage']"
                >
                  <a-icon :type="currentWithMaskImgUploading?'loading':'upload'" /> {{$t('personalManaEdit.uploadPhotoBtn')}}
                </a-upload>
              </template>
            </a-card>
          </a-form-item>
          <!-- 证件照 -->
          <a-form-item class="inline-form-item" :label="$t('personalManaEdit.IDCardPhotoTxt')">
            <a-card class="a-card-image">
              <img
                v-if="!idCardImageUrl"
                src="../../assets/empty_person.png"
                slot="cover"
              />
              <img v-else :src="idCardImageUrl" slot="cover" />

              <template class="ant-card-actions" slot="actions">
                <WSReadCard
                  :readMode="1"
                  @readSuccess="handleReadIDCard"
                >
                  <template v-slot:default="slotProps">
                    <span
                      @click="slotProps.readFunc"
                      :style="slotProps.reading ? 'cursor:not-allowed;color:#8C8C8C' : 'color:#595959;'">
                      <a-icon type="idcard" /> {{$t('personalManaEdit.readIDCardBtn')}}
                    </span>
                  </template>
                </WSReadCard>
              </template>

            </a-card>
          </a-form-item>
          <a-form-item class="upload-image-tip">{{$t('personalManaEdit.uploadImageDesc')}}</a-form-item>
        </a-col>

        <a-col :span="24" class="padding-tb-md">
          <h3 class="panle-head">{{$t('personalManaEdit.basicInfoTitle')}}</h3>
          <!-- 姓名 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.name')">
              <a-input
                :placeholder="$t('personalManaEdit.nameTxt')"
                v-decorator="[ 'name', {
                    rules: [
                      { required: true,message: $t('personalManaEdit.nameBlank') },
                      { max: 20,message: $t('personalManaEdit.nameWarning') }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 证件类型 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.IDType')">
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                :placeholder="$t('personalManaEdit.IDTypeTxt')"
                :options="idCardTypeOptions"
                @change="type => idCardType = type"
                v-decorator="[ 'idCardType', {
                    rules: [{ required: false, message: $t('personalManaEdit.IDTypeBlank') }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 证件号 -->
          <a-col :span="8">
            <!-- 身份证 -->
            <a-form-item :label="$t('personalManaEdit.IDNumber')" v-if="idCardType === 1">
              <a-input
                :placeholder="$t('personalManaEdit.IDNumberTxt')"
                v-decorator="['idNumber', {
                  rules: [
                    { required: false, message: $t('personalManaEdit.IDNumberBlank') },
                    { validator: checkIdNumber }
                  ]
                }]"
              />
            </a-form-item>
            <!-- 护照 -->
            <a-form-item :label="$t('personalManaEdit.passportNumber')" v-if="idCardType === 2">
              <a-input
                :placeholder="$t('personalManaEdit.passportNumberTxt')"
                v-decorator="['passportNumber',{
                  rules: [{ required: false, message: $t('personalManaEdit.passportNumberBlank') }]
                }]"
              />
            </a-form-item>
            <!-- 港澳通行证 -->
            <a-form-item :label="$t('personalManaEdit.gatePassNumber')" v-if="idCardType === 3">
              <a-input
                :placeholder="$t('personalManaEdit.gatePassNumberTxt')"
                v-decorator="['gatePassNumber',{
                  rules: [{ required: false, message: $t('personalManaEdit.gatePassNumberBlank') }]
                }]"
              />
            </a-form-item>
          </a-col>
          <!-- 性别 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.sex')">
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                :placeholder="$t('personalManaEdit.sexTxt')"
                :options="enumsData.gender"
                v-decorator="[ 'sex' ]"
              />
            </a-form-item>
          </a-col>
          <!-- 民族 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.nationality')">
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                :placeholder="$t('personalManaEdit.nationalityTxt')"
                :options="enumsData.ethnicity"
                v-decorator="[ 'nation' ]"
              />
            </a-form-item>
          </a-col>
          <!-- 出生日期 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.birthday')">
              <a-date-picker
                dropdownClassName="form-date-picker"
                :getCalendarContainer="trigger => trigger.parentNode"
                style="width: 100%"
                :placeholder="$t('personalManaEdit.birthdayTxt')"
                v-decorator="[ 'birthday' ]"
              />
            </a-form-item>
          </a-col>
          <!-- 手机号 -->
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.phone')">
              <a-input
                :placeholder="$t('personalManaEdit.phoneTxt')"
                v-decorator="[ 'phone', {
                    rules: [{
                        required: true,
                        message: $t('personalManaEdit.phoneBlank')
                      },{ pattern: /^1[3456789]\d{9}$/, message: $t('personalManaEdit.phoneWarning')}]
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 地址 -->
          <a-col :span="16">
            <a-form-item :label="$t('personalManaEdit.address')">
              <a-input
                :placeholder="$t('personalManaEdit.addressTxt')"
                v-decorator="[ 'address',{
                    rules: [{ max: 100, message: $t('personalManaEdit.addressWarning')}]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <!-- 备注 -->
          <a-col :span="24">
            <a-form-item :label="$t('personalManaEdit.remark')">
              <a-input
                :placeholder="$t('personalManaEdit.remarkTxt')"
                v-decorator="[ 'remark', {
                    rules: [{ max: 20, message: $t('personalManaEdit.remarkWarning') }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-col>

        <a-col :span="24" class="padding-tb-md">
          <h3 class="panle-head">{{$t('personalManaEdit.ICCardTitle')}}</h3>
          <a-col :span="8">
            <a-form-item :label="$t('personalManaEdit.bindICCard')">
              <a-input
                placeholder=""
                v-decorator="[ 'icCardNumber' ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8" style="margin-top: 42px">
            <WSReadCard
              :readMode="2"
              @readSuccess="handleReadICCard"
            >
              <template v-slot:default="slotProps">
                <a-button
                  type="primary"
                  style="margin-right: 10px"
                  :loading="slotProps.reading"
                  @click="slotProps.readFunc"
                >{{$t('personalManaEdit.readICCardBtn')}}</a-button>
              </template>
            </WSReadCard>
          </a-col>
        </a-col>
      </a-row>

      <a-row style="margin-top: 16px;">
        <a-col :span="24" :style="{ textAlign: 'right' }">
          <a-button
            type="primary"
            htmlType="submit"
            :loading="submitting"
          >{{$t('personalManaEdit.submitBtn')}}</a-button>
          <a-button
            :style="{ marginLeft: '8px' }"
            @click="handleBackPage"
          >{{$t('personalManaEdit.closeBtn')}}</a-button>
        </a-col>
      </a-row>
    </a-form>

    <!-- 拍照模态框  -->
    <Camera
      :show="takePhotoModalVisible"
      @hideModal="handleHideCameraModal"
      @afterUploadPhoto="handleAfterUploadPhoto"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { checkIdNumberValid, compressImageFile } from '@/utils/utils';
import { mapState } from 'vuex';

import WSReadCard from '@/components/WSReadCard/WSReadCard';
import Camera from '@/components/Camera/Camera';

import { uploadBase64Img } from '@/api/fileUpload';
import { getPersonalDetail, modifyPerson } from '@/api/personalMana';

export default {
  name: 'personalManaEdit',
  components: { WSReadCard, Camera },
  data() {
    return {
      personInfo: null,

      form: this.$form.createForm(this),
      idCardTypeOptions: [],
      idCardType: 1,
      submitting: false,

      // 证件照
      idCardImageUrl: '',

      // 上传现场照片
      currentImgUploading: false,
      // 上传佩戴口罩的现场照片
      currentWithMaskImgUploading: false,
      // 现场照
      currentImage: null,
      // 佩戴口罩现场照
      currentWithMaskImage: null,

      // 要拍摄照片的类型
      takePhotoType: 1, // 1: 人员现场照；2：人员佩戴口罩的现场照

      // 拍摄照片模态框
      takePhotoModalVisible: false
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData
    })
  },
  beforeCreate() {
    // console.log('----personalManaEdit beforeCreate------', this.$route.params)
    if (!this.$route.query.pi) {
      this.$error({
        title: this.$t('personalManaEdit.pageErrTitle'),
        content: this.$t('personalManaEdit.pageErrContent'),
        okText: this.$t('personalManaEdit.backBtn'),
        onOk: () => {
          this.$multiTab.closeCurrentPage();
          this.$router.push({ name: 'personalManaIndex' });
        }
      });
    }
  },
  created() {
    this.idCardTypeOptions = this.enumsData.idType.map(item => {
      // 限制证件类型只能选择身份证
      if (item.value !== 1) item.disabled = true
      return item
    })
  },
  activated() {
    if (this.$route.query.pi !== this.personId) {
      this.$multiTab.close('/personal-mana/new')
      this.personId = this.$route.query.pi
      this.getPersonalDetailInfo();
    }
  },
  methods: {
    moment,

    // 验证身份证号
    checkIdNumber(rule, value, callback) {
      if (value && !checkIdNumberValid(value)) {
        callback(this.$t('personalManaEdit.IDNumberWarning'));
        return;
      }
      callback();
    },
    // 获取人员信息
    async getPersonalDetailInfo() {
      try {
        const res = await getPersonalDetail({ id: this.personId })
        this.personInfo = res.data.collection[0]
        // console.log(this.personInfo)
        this.form.resetFields()

        this.idCardImageUrl = this.personInfo.idPhotoUrl || '';
        this.currentImage = this.personInfo.scenePhotoUrl || '';
        this.currentWithMaskImage = this.personInfo.scenePhoto2Url || '';

        this.$nextTick(this.setPersonnelFormFieldsValue)
      } catch (error) {}
    },
    // 设置人员信息表单
    setPersonnelFormFieldsValue() {
      this.form.setFieldsValue({
        currentImage: this.currentImage,
        currentWithMaskImage: this.currentWithMaskImage,
        name: this.personInfo.name,
        idCardType: this.personInfo.certificationTypeCode,
        sex: this.personInfo.genderCode === null ? undefined : this.personInfo.genderCode,
        nation: this.personInfo.ethnicityCode === null ? undefined : this.personInfo.ethnicityCode,
        birthday: this.personInfo.birthDate ? moment(this.personInfo.birthDate) : null,
        phone: this.personInfo.phone,
        address: this.personInfo.address,
        remark: this.personInfo.remark,
        icCardNumber: this.personInfo.cardSn
      })
      // 根据证件类型设置证件号字段值
      switch (this.personInfo.certificationTypeCode) {
        case 1: this.form.setFieldsValue({ idNumber: this.personInfo.idNumber }); break;
        case 2: this.form.setFieldsValue({ passportNumber: this.personInfo.idNumber }); break;
        case 3: this.form.setFieldsValue({ gatePassNumber: this.personInfo.idNumber }); break;
        default: break;
      }
    },

    // 提交人员信息
    handlePersonInfoSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.submitting = true
            await modifyPerson({
              id: this.personId,
              address: values.address,
              birthDate: values.birthday ? values.birthday.format('YYYY-MM-DD') : '',
              cardSn: values.icCardNumber,
              certificationTypeCode: Number(values.idCardType),
              deptId: this.personInfo.deptId,
              ethnicityCode: Number(values.nation),
              genderCode: Number(values.sex),
              idNumber: values.idNumber,
              idPhotoUrl: this.idCardImageUrl,
              name: values.name,
              phone: values.phone,
              remark: values.remark,
              scenePhoto2Url: this.currentWithMaskImage,
              scenePhotoUrl: this.currentImage
            })
            this.submitting = false

            this.$notification.success({
              message: this.$t('personalManaEdit.editPersonalSuccess'),
              duration: 2
            });
            setTimeout(() => {
              this.handleBackPage();
            }, 2000)
          } catch (error) {
            this.submitting = false
          }
        }
      });
    },

    // 返回
    handleBackPage() {
      this.$multiTab.closeCurrentPage();
      this.$router.go(-1)
    },

    // 上传拍摄照片后
    handleAfterUploadPhoto(data) {
      if (this.takePhotoType === 1) {
        this.currentImage = data.data.collection[0];
        this.form.setFieldsValue({ currentImage: this.currentImage })
      }
      if (this.takePhotoType === 2) {
        this.currentWithMaskImage = data.data.collection[0];
        this.form.setFieldsValue({ currentWithMaskImage: this.currentWithMaskImage })
      }
    },
    // 关闭拍照模态框
    handleHideCameraModal(data) {
      this.takePhotoModalVisible = data
    },

    // 上传照片前
    async handleBeforeUploadPhoto(file, type) {
      try {
        if (type === 1) this.currentImgUploading = true;
        if (type === 2) this.currentWithMaskImgUploading = true;

        compressImageFile(file, image => {
          this.handleUploadPhoto(image, type)
        })
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
      } catch (error) {
        this.currentImgUploading = this.currentWithMaskImgUploading = false;
        this.$message.error(this.$t('personalManaEdit.uploadFail'));
        return Promise.reject(error)
      }

    },
    // 上传照片
    async handleUploadPhoto(image, type) {
      try {
        if (type === 1) this.currentImgUploading = true;
        if (type === 2) this.currentWithMaskImgUploading = true;

        const base64Unhead = image.base64.replace(/^data:image\/\w+;base64,/, '')
        const res = await uploadBase64Img({ data: base64Unhead, suffix: 'jpg' })

        if (type === 1) {
          this.currentImgUploading = false;
          this.currentImage = res.data.collection[0];
          this.form.setFieldsValue({ currentImage: this.currentImage })
        }
        if (type === 2) {
          this.currentWithMaskImgUploading = false;
          this.currentWithMaskImage = res.data.collection[0];
          this.form.setFieldsValue({ currentWithMaskImage: this.currentWithMaskImage })
        }

        this.$message.success(`${image.name} ${this.$t('personalManaEdit.uploadSuccess')}`);
      } catch (error) {
        this.currentImgUploading = this.currentWithMaskImgUploading = false;
        this.$message.error(`${image.name} ${this.$t('personalManaEdit.uploadFail')}`);
      }
    },

    // handleImageFileChange(file) {
    //   console.log('-------')
    //   if (file.file.status === 'removed') {
    //     this.currentImage = ''
    //   }
    //   return this.currentImage
    // },

    // websocket 方式读取身份证信息
    async handleReadIDCard(data) {
      try {
        this.form.setFieldsValue({
          name: data.name,
          idNumber: data.idNumber,
          idCardType: 1, // 身份证
          sex: data.sex,
          nation: data.nation,
          birthday: this.moment(data.birthday),
          address: data.address
        });
        this.idCardImageUrl = 'data:image/png;base64,' + data.image;

        const res = await uploadBase64Img({ data: data.image, suffix: 'png' })
        this.idCardImageUrl = res.data.collection[0]
      } catch (error) {}
    },

    // websocket 方式读取IC信息
    handleReadICCard(data) {
      this.form.setFieldsValue({
        icCardNumber: data.number
      })
    }
  }
};
</script>
<style>
.inline-form-item{
  display: inline-block;
  margin: 0 15px;
}
.a-card-image>.ant-card-cover{
  width: 220px;
  height: 293px;
  padding: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.a-card-image>.ant-card-cover>img{
  max-height: 100%;
  max-width: 100%;
}
</style>
<style scoped>
.brief-bar {
  background-color: #fff;
  margin: 5px 0;
  padding: 10px 16px;
  border-radius: 5px;
}
.brief-bar .brief-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 10px;
}
.brief-bar .brief-subtitle {
  margin-right: 10px;
  color: #999;
}
.submit-btn-area{
  padding: 10px 20px;
  background: #fff;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #e8e8e8;
}
.upload-image-tip{
  font-size: 12px;
  line-height: 20px;
  margin: 5px 15px 0 15px;
  color: rgba(0,0,0,.45);
}
</style>
